import { useState, useEffect } from "react";
import { FetchProviderTypes } from "../../api/FetchProviderTypes";
import { ProviderType } from "../../helpers/interfaces/ProvidersInterfaces";

let cachedData: ProviderType[] | null = null;

export const useFetchProviderTypes = () => {
  const [providerTypes, setProviderTypes] = useState<ProviderType[]>(cachedData || []);
  const [loading, setLoading] = useState(!cachedData);

  useEffect(() => {
    if (cachedData) {
      return;
    }

    const loadData = async () => {
      setLoading(true);
      const response = await FetchProviderTypes();

      if (response && response.data) {
        // The /list API returns a direct array of objects
        const data: ProviderType[] = Array.isArray(response.data) ? response.data : response.data.data || [];
        cachedData = data;
        setProviderTypes(data);
      }
      setLoading(false);
    };

    loadData();
  }, []);

  return { providerTypes, loading };
};
